angular.module('document')
    .component('priorityPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<",
            modelType: '<',
            onChange: "&"
        },
        templateUrl: "app/document/priority-picker.html",
        controller: function(Priority) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;

                Priority.list().$promise.then(items => ctrl.items = items);

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
        }
    })
